import { useEnabledEngagementChannels } from './use-enabled-engagement-channels.hook';

const MIN_ENABLED_CHANNELS_COUNT = 2;

export const useCanShowMultipleEnabledBanner = () => {
  const enabledChannels = useEnabledEngagementChannels();

  return enabledChannels.length >= MIN_ENABLED_CHANNELS_COUNT;
};
